import ctx from "@/ctx";
import fetch from "../../utils/fetch";

let Items = function(d) {
  let self = this;
  self.items = d || [];

  self.get = function(id) {
    return self.items.find(i => i.id == id);
  };
};

export default async () => {
  console.log("ctx.src.kinship: loaded");
  const res = await fetch.get("/api/kinship/get-list");
  if (res) ctx.src.kinship = new Items(res);
  console.log("ctx.src.kinship: initialized");
};
